import * as api from "@/services/device";
import { IApiResponse, IFetchdevice } from "@/services/device/device.type";
import { isBoolean } from "lodash";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from '@/store/slices/device.slice';
import { PayloadAction } from "@reduxjs/toolkit";
import { GET_DEVICE_ACTION_TYPE } from "@/constant/device/device.constant";
import { isSameRequestParams } from "@/utils/requestParamsChecker";


// Defines a specific action type for getting a device by ID
export interface getDeviceAction extends PayloadAction<number> {
  type: 'device/getDevice';
}
export interface GetDevicesListAction extends PayloadAction<number> {
  type: "device/getDevicesList";
}

// Saga function for handling API calls to fetch device data based on an action
function* getDevice(action: getDeviceAction): Generator {
  try {
    const response: any = yield call(api.fetchDevice as any, action.payload)
    //handling If the response data is valid, dispatch a success action with the data
    if (isValidDevicedata(response?.data) || response?.data?.success) {
      yield put(actions.getDeviceSuccess(response?.data));
    }
    // handling If the response data is invalid, dispatch a failure action
    else {
      yield put(actions.getDeviceFailure());
    }
  }
  // Handles any errors that occur during the API call by dispatching a failure action
  catch (error: any) {
    yield put(actions.getDeviceFailure());
  }
}

// here validating the API response data structure and content
function isValidDevicedata(response: IApiResponse): boolean {
  return (
    isBoolean(response.success) &&
    response.message === 'Succesfully grabbed devices.'
  );
}
function* getDevicesList(action: PayloadAction<IFetchdevice>): Generator {
  try {
    const response: any = yield call(api.fetchAllDevicesList as any, action?.payload);
    const { operatorId, marketId, page, limit } = action.payload;
    if (isValidDevicedata(response?.data) || response?.data?.success) {
      yield put(actions.getDevicesListSuccess({
        ...response?.data,
        operatorId: operatorId,
        marketId: marketId,
      }));
    } else {
      yield put(actions.getDevicesListFailure(response?.data));
    }
  } catch (error: any) {
    yield put(actions.getDevicesListFailure(error?.response?.data));
  }
}

// watch for the getDevice action and trigger getDevice saga
function* deviceSaga(): Generator {
  yield takeLatest<getDeviceAction>(GET_DEVICE_ACTION_TYPE, getDevice)
  yield takeLatest(actions.getDevicesList.type, getDevicesList);
}

export default deviceSaga;